<template>
  <a-modal v-model="visible" title="" :footer="null" width="700px" :bodyStyle="{ minHeight: '300px' }" @cancel="closeModal(true)">
    <div class="modal-container">
      <a-form-model v-if="!isMatchError" ref="formRef" :rules="rules" :model="form" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-divider orientation="left">{{ options.id ? '考试信息修改' : '上传成绩' }}</a-divider>
        <a-form-model-item label="机构名称" prop="organizationId" v-if="!options.organizationId">
          <a-select v-model="form.organizationId" :disabled="!!options.id" placeholder="请选择机构名称" show-search :filter-option="filterOption" allowClear>
            <a-select-option v-for="item in orgList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="考试名称" prop="examName">
          <a-input v-model="form.examName" placeholder="不超过35个字符" :maxLength="35" />
        </a-form-model-item>
        <a-form-model-item label="考试时间" prop="examTime">
          <a-date-picker style="width: 100%" placeholder="请选择日期" v-model="form.examTime" />
        </a-form-model-item>
        <a-form-model-item label="考试学期" prop="term">
          <a-select v-model="form.term" placeholder="请选择考试学期">
            <a-select-option :value="1"> 上学期 </a-select-option>
            <a-select-option :value="2"> 下学期 </a-select-option>
            <a-select-option :value="0"> 其他 </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="考试类型" prop="type">
          <a-select v-model="form.type" placeholder="请选择考试类型">
            <a-select-option :value="0"> 普通小考 </a-select-option>
            <a-select-option :value="1"> 期末考试</a-select-option>
            <a-select-option :value="2"> 期中考试 </a-select-option>
            <a-select-option :value="3"> 中高考模拟考 </a-select-option>
            <a-select-option :value="4"> 开学摸底考 </a-select-option>
            <a-select-option :value="5"> 分班考试 </a-select-option>
            <a-select-option :value="6"> 区域统考 </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="form.remark" placeholder="不超过100个字符" :maxLength="100" />
        </a-form-model-item>
      </a-form-model>
      <template v-else>
        <a-divider orientation="left"><h2>匹配成绩</h2></a-divider>
        <div class="upload-error">
          <h2 class="upload-error-title">匹配失败！</h2>
          <div class="upload-error-desc">{{ options.matchErrorMsg || '选择的成绩与此次分析的学生不匹配，请下载不匹配名单，补全成绩，或重新选择成绩！' }}</div>
        </div>
        <a-divider orientation="left">不匹配学生下载</a-divider>
        <div class="error-data upload-error-down" @click="downLoadGradeError">点击下载名单</div>
      </template>
      <template v-if="!isResponsible && isMatchError">
        <a-divider orientation="left">成绩负责人</a-divider>
        <a-row style="text-align: center">
          <p class="upload-error-desc">此成绩负责人为：{{ options.exam.operatorName }}，请联系该负责人修改成绩</p>
          <a-button class="upload-error-comfrim" type="primary" @click="closeModal(true)">确认</a-button>
        </a-row>
      </template>
      <template v-else>
        <a-spin :spinning="uploadLoading">
          <a-divider orientation="left">数据模板下载</a-divider>
          <p style="text-align: center">
            <a download="成绩导入模板" :href="DownloadTemplate" title="成绩导入模板">点击下载模板</a>
          </p>
          <a-divider orientation="left">批量导入学生</a-divider>
          <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
            <p class="ant-upload-drag-icon">
              <a-icon type="cloud-upload" />
            </p>
            <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
            <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
          </a-upload-dragger>
        </a-spin>
        <div class="error-data" v-if="errorData.grade" @click="downLoadImportError">下载错误数据</div>
        <div class="modal-tip" style="margin: 20px 0">温馨提示：学生姓名，性别，出生日期如有一项不同系统即可识别不同学生，但为了方便教师使用建议提前修改姓名区分，如刘伟（大），刘伟（小）</div>
        <p style="text-align: center; margin: 20px 0">
          <a-button :loading="confirmLoading" @click="submit" type="primary">保存数据</a-button>
        </p>
      </template>
    </div>
  </a-modal>
</template>
<script>
import moment from 'moment'
import { arrayToXlsx } from '@/utils/util'
import { mapState } from 'vuex'

export default {
  name: 'UploadStudent',
  data() {
    return {
      DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/%E6%88%90%E7%BB%A9%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx',
      form: {
        examTime: '',
        examName: undefined,
        term: undefined,
        type: undefined,
        remark: undefined,
        organizationId: undefined,
      },
      rules: {
        examTime: [{ required: true, message: '请选择时间' }],
        examName: [{ required: true, message: '请输入内容' }],
        term: [{ required: true, message: '请选择考试学期', trigger: ['change'] }],
        organizationId: [{ required: true, message: '请选择机构名称', trigger: ['change'] }],
        type: [{ required: true, message: '请选择类型', trigger: ['change'] }],
      },
      uploadLoading: false,
      fileList: [],
      orgList: [],
      confirmLoading: false,
      visible: false,
      errorData: {
        grade: null,
      },
      matchData: {
        grade: null,
      },
      options: {},
    }
  },
  computed: {
    ...mapState('account', ['user']),
    // 是否是成绩负责人
    isResponsible() {
      const exam = this.options.exam || {}
      return this.user.id === exam.operatorId
    },
    //是否有匹配错误
    isMatchError() {
      return !!this.options.matchError
    },
  },
  methods: {
    async submit() {
      this.$refs['formRef'] && (await this.$refs['formRef'].validate())
      if (!this.fileList[0] && !this.options.id) {
        return this.$message.error('请上传文件')
      }
      if (!this.fileList[0] && this.options.matchError) {
        return this.$message.error('请上传文件')
      }
      this.confirmLoading = true

      const fm = new FormData()
      fm.append('examTime', moment(this.form.examTime).format('YYYY-MM-DD HH:mm:ss'))
      fm.append('examName', this.form.examName)
      fm.append('type', this.form.type)
      this.fileList[0] && fm.append('excelfile', this.fileList[0])
      fm.append('term', this.form.term)
      fm.append('remark', this.form.remark || '')
      fm.append('organizationId', this.form.organizationId)
      // fm.append('operatorId', this.user.id)
      // fm.append('operatorName', this.user.realName)
      if (this.options.id) {
        fm.append('id', this.options.id)
      }
      const { data, isSuccess } = await this.$http.ReportService.importExamScore(fm)
        .finally(() => (this.confirmLoading = false))
        .catch((err) => err)
      if (isSuccess) {
        if (!this.options.noMsg) {
          this.$message.success('操作成功')
        }
        this.closeModal(false, { ...this.form, file: this.fileList[0] })
        this.errorData.grade = null
        return
      }
      if (data?.length) {
        this.errorData.grade = data
      }
    },
    downLoadGradeError() {
      if (!this.matchData.grade) return
      const columns = ['姓名', '性别', '出生日期', '错误信息']
      const exportKeys = ['realName', 'genderName', 'birthday', 'errorMessage']
      const exportData = []
      const orignData = this.matchData.grade.map((v) => v.errorStudent).flat(2)
      console.log(orignData)

      for (let i = 0; i < orignData.length; i++) {
        const item = orignData[i]
        const reulst = []
        exportKeys.forEach((key) => {
          const val = Array.isArray(item[key]) ? item[key].join('，') : item[key]
          reulst.push(val)
        })
        exportData.push(reulst)
      }
      arrayToXlsx(exportData, {
        columns,
        fileName: '错误数据.xlsx',
        generate: (obj) => {
          obj.setColumnFontColor({
            cell: 'D',
            len: orignData.length + 1,
            color: 'FF0000',
          })
          obj.aoa['!cols'] = Array.from({ length: columns.length }, (_, i) => (i + 1 === columns.length ? { wpx: 140 } : { wpx: 100 }))
        },
      })
    },

    downLoadImportError() {
      if (!this.errorData.grade) return
      const columns = ['姓名', '性别', '出生日期', '语文成绩（必填）', '数学成绩（必填）', '英语成绩（必填）', '物理成绩', '化学成绩', '生物成绩', '政治成绩', '历史成绩', '地理成绩', '错误信息']
      const exportKeys = [
        'realName',
        'genderName',
        'birthday',
        'chineseScore',
        'mathScore',
        'englishScore',
        'physicsScore',
        'chemistryScore',
        'biologyScore',
        'politicsScore',
        'historyScore',
        'geographyScore',
        'errorMessage',
      ]
      const exportData = []
      let maxErorrLen = 1
      for (let i = 0; i < this.errorData.grade.length; i++) {
        const item = this.errorData.grade[i]
        const reulst = []
        exportKeys.forEach((key) => {
          const val = Array.isArray(item[key]) ? item[key].join('，') : item[key]
          if (key === 'errorMessage') {
            maxErorrLen = Math.max(maxErorrLen, item[key]?.length || 0)
          }
          reulst.push(val)
        })
        exportData.push(reulst)
      }
      arrayToXlsx(exportData, {
        columns,
        fileName: '错误数据.xlsx',
        generate: (obj) => {
          obj.setColumnFontColor({
            cell: 'M',
            len: this.errorData.grade.length + 1,
            color: 'FF0000',
          })
          obj.aoa['!cols'] = Array.from({ length: columns.length }, (_, i) => (i + 1 === columns.length ? { wpx: 140 * maxErorrLen } : { wpx: 100 }))
        },
      })
    },

    showModal(options = {}) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.visible = true
        this.options = options
        if (options.id) {
          const exam = options.exam
          this.form.examTime = exam.examTime
          this.form.examName = exam.examName
          this.form.term = exam.term
          this.form.type = exam.type
          this.form.remark = exam.remark
          this.form.organizationId = exam.organizationId
        }
        if (options.matchError) {
          this.matchData.grade = options.matchError
        }
        !options.organizationId ? this.getOrgList() : (this.form.organizationId = options.organizationId)
      })
    },
    closeModal(reject, params) {
      reject ? this._reject(params) : this._resolve(params)
      this.visible = false
      this.form = {
        examTime: '',
        examName: undefined,
        term: undefined,
        type: undefined,
        remark: undefined,
        organizationId: undefined,
      }
      this.fileList = []
      this.errorData.grade = null
      this.matchData.grade = null
      this.$refs['formRef'] && this.$refs['formRef'].resetFields()
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      if (!['xlsx', 'xls'].includes(file.name.substr(-4, 4))) {
        this.$message.error('请选择以“.xlsx，.xls”结尾的文件')
        return false
      }
      this.fileList = [file]
      this.errorData.grade = null
      return false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getOrgList() {
      if (this.options.matchError) return
      this.$http.loadAllByType({ isOnlySuperior: false, orgType: 1 }).then((res) => {
        const { data, status } = res.data
        this.orgList = data
      })
    },
  },
}
</script>
<style lang="less" scoped>
.error-data {
  color: red;
  cursor: pointer;
  margin-top: 10px;
}
.upload-error {
  text-align: center;
  padding: 20px 80px;
}
.upload-error-title {
  color: red;
}
.upload-error-desc {
  color: red;
  text-align: center;
  font-size: 16px;
}
.upload-error-comfrim {
  text-align: center;
  margin-top: 50px;
}
.upload-error-down {
  text-align: center;
}
</style>
